import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { connect } from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Snackbar from '@material-ui/core/Snackbar';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";

import Close from "@material-ui/icons/Close";
import AccountCircle from "@material-ui/icons/AccountCircle";
import Assignment from "@material-ui/icons/Assignment";
import Check from "@material-ui/icons/Check";

import GridContainer from "../../../components/Grid/GridContainer.jsx";
import GridItem from "../../../components/Grid/GridItem.jsx";
import Button from "../../../components/CustomButtons/Button.jsx";
import Card from "../../../components/Card/Card.jsx";
import CardHeader from "../../../components/Card/CardHeader.jsx";
import CardBody from "../../../components/Card/CardBody.jsx";
import CustomInput from "../../../components/CustomInput/CustomInput.jsx";

import CustomNotification from "../../LandingPage/Sections/CustomNotification";

import javascriptStyles from "../../../assets/jss/material-kit-pro-react/views/componentsSections/javascriptStyles.jsx";

import { loginUser, registerUser } from '../../../actions/authActions';

function Transition(props) {
    return <Slide direction="down" {...props} />;
}

class SectionAuth extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            classicModal: false,
            noticeModal: false,
            smallModal: false,
            loginModal: false,
            signupModal: false,
            openLeft: false,
            openTop: false,
            openBottom: false,
            openRight: false,
            errors: {},

            openNotification: false,
            variantNotification: '',
            messageNotification: '',
            usernameLogin: '',
            passwordLogin: '',

            first_name: '',
            last_name: '',
            usernameSignup: '',
            email: '',
            phone: '',
            passwordSignup: '',
            passwordConfirmation: '',
            checked: [1]
        };
    }

    // componentWillReceiveProps(nextProps) {
    //     if (!!nextProps.errors && !!nextProps.errors.message) {
    //         this.handleClickNotification(nextProps.errors.message, 'error');
    //         let errors = {};
    //         if (!!nextProps.errors.errors && nextProps.errors.errors.length>0) {
    //             for (let i=0; i<nextProps.errors.errors.length; i++) {
    //                 let actualField = nextProps.errors.errors[i];
    //                 errors[actualField.field] = actualField.message;
    //             }
    //             this.setState({ errors });
    //         }
    //     }
    // }

    handleClickNotification = (messageNotification, variantNotification) => {
        this.setState({ openNotification: true, messageNotification, variantNotification });
    };

    handleCloseNotification = (event, reason) => {
        if (reason === 'clickaway') { return; }
        this.setState({ openNotification: false });
    };

    onChangeCustomInput = () => e => {
        if (!!e.target.id) {
            if (e.target.id==='first_name') {
                this.setState({ usernameSignup: e.target.value.toLowerCase().replace(/ /g,'') });
            }
            this.setState({ [e.target.id]: e.target.value, errors: {} });
        } else {
            console.error('Error actualizando la informacion ingresada', 'error');
        }
    };

    onSubmitLogin = e => {
        e.preventDefault();

        const { usernameLogin, passwordLogin } = this.state;

        let userData = {
            username: usernameLogin,
            password: passwordLogin
        };

        this.props.loginUser(userData);
    };

    onSubmitSignup = e => {
        e.preventDefault();

        const { first_name, last_name, email, usernameSignup, phone, passwordSignup, passwordConfirmation, checked } = this.state;

        if (checked.length > 0) {
            if (passwordSignup !== '' && passwordConfirmation!=='') {
                if (passwordSignup === passwordConfirmation) {
                    if (passwordSignup.length>=6 && passwordConfirmation.length>=6) {
                        if (phone!=='') {

                            let newUser = {
                                first_name,
                                last_name,
                                email,
                                username: usernameSignup,
                                phone,
                                password: passwordSignup
                            };

                            this.props.registerUser(newUser);

                        } else {
                            let errors = { phone:"Ingresa un número de teléfono" };
                            this.setState({ errors });
                        }
                    } else {
                        let errors = {
                            password:"La Contraseña debe tener mínimo 6 caracteres",
                            passwordConfirmation:"La Contraseña debe tener mínimo 6 caracteres"
                        };
                        this.setState({ errors });
                    }
                } else {
                    let errors = {
                        password:"Los campos no coinciden",
                        passwordConfirmation:"Los campos no coinciden"
                    };
                    this.setState({ errors });
                    this.handleClickNotification('La contraseña y la confirmación de contraseña deben coincidir', 'warning');
                }
            } else {
                let errors = {
                    password:"Diligencia este campo",
                    passwordConfirmation:"Diligencia este campo"
                };
                this.setState({ errors });
                this.handleClickNotification('Por favor ingresa la contraseña y la confirmación de contraseña', 'warning');
            }
        } else {
            this.handleClickNotification('Debes aceptar los Términos y Condiciones', 'warning');
        }
    };

    handleToggle = value => {
        const { checked } = this.state;
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];

        currentIndex === -1 ? newChecked.push(value) : newChecked.splice(currentIndex, 1);

        this.setState({ checked: newChecked });
    };

    handleClickOpen(modal) {
        let x = [];
        x[modal] = true;
        this.setState(x);
    }

    handleClose(modal) {
        let x = [];
        x[modal] = false;
        this.setState(x);
    }

    // handleClosePopover(state) {
    //     this.setState({
    //         [state]: false
    //     });
    // }
    //
    // handleClickButton(state) {
    //     this.setState({
    //         [state]: true
    //     });
    // }

    render() {
        const { classes } = this.props;
        const { errors } = this.state;

        return (
            <div className={classes.container}>
                <GridContainer>
                    <GridItem xs={12} sm={6} md={6} lg={6}>
                        {/* Button open Login Modal */}
                        <p>¿Ya tienes una cuenta en Vivamos el Campo?</p>
                        <Button
                            block
                            round
                            color="success"
                            onClick={() => this.handleClickOpen("loginModal")}
                        >
                            <AccountCircle /> Inicia Sesión
                        </Button>
                        {/* End Button open Login Modal */}

                        {/* Login Modal */}
                        <Dialog
                            classes={{ root: classes.modalRoot, paper: classes.modal + " " + classes.modalLogin }}
                            open={this.state.loginModal}
                            TransitionComponent={Transition}
                            keepMounted
                            onClose={() => this.handleClose("loginModal")}
                            aria-labelledby="login-modal-slide-title"
                            aria-describedby="login-modal-slide-description"
                        >
                            {/* Custom Notification */}
                            <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={this.state.openNotification} autoHideDuration={6000} onClose={this.handleCloseNotification}>
                                <CustomNotification onClose={this.handleCloseNotification} variant={this.state.variantNotification} message={this.state.messageNotification}/>
                            </Snackbar>
                            {/* End Custom Notification */}

                            <Card plain className={classes.modalLoginCard}>
                                <DialogTitle
                                    id="login-modal-slide-title"
                                    disableTypography
                                    className={classes.modalHeader}
                                >
                                    <CardHeader plain color="success" className={classnames(classes.textCenter, classes.cardLoginHeader)}>
                                        <Button
                                            simple
                                            className={classes.modalCloseButton}
                                            key="close"
                                            aria-label="Close"
                                            onClick={() => this.handleClose("loginModal")}
                                        >
                                            {" "}
                                            <Close className={classes.modalClose} />
                                        </Button>

                                        <h5 className={classes.cardTitleWhite}>Ingresar</h5>
                                        {/*<div className={classes.socialLine}>
                                            <Button
                                                justIcon
                                                link
                                                className={classes.socialLineButton}
                                            >
                                                <i className="fab fa-facebook-square" />
                                            </Button>
                                            <Button
                                                justIcon
                                                link
                                                className={classes.socialLineButton}
                                            >
                                                <i className="fab fa-twitter" />
                                            </Button>
                                            <Button
                                                justIcon
                                                link
                                                className={classes.socialLineButton}
                                            >
                                                <i className="fab fa-google-plus-g" />
                                            </Button>
                                        </div>*/}
                                    </CardHeader>
                                </DialogTitle>

                                <form className={classes.form} onSubmit={this.onSubmitLogin}>
                                    <DialogContent id="login-modal-slide-description" className={classes.modalBody}>
                                        <p className={`${classes.description} ${classes.textCenter}`}>
                                            Ingresa tus datos
                                        </p>

                                        <CardBody className={classes.cardLoginBody}>
                                            <CustomInput
                                                id="usernameLogin"
                                                formControlProps={{ fullWidth: true }}
                                                labelText= {!!errors.username ? errors.username : "Email o nombre de usuario"}
                                                error = {!!errors.username}
                                                inputProps={{
                                                    // type: "username",
                                                    defaultValue: this.state.usernameLogin,
                                                    onChange: this.onChangeCustomInput(),
                                                    required: true
                                                }}
                                            />

                                            <CustomInput
                                                id="passwordLogin"
                                                labelText= {!!errors.password ? errors.password : "Contraseña"}
                                                error = {!!errors.password}
                                                formControlProps={{ fullWidth: true }}
                                                inputProps={{
                                                    type: "password",
                                                    defaultValue: this.state.passwordLogin,
                                                    onChange: this.onChangeCustomInput(),
                                                    required: true
                                                }}
                                            />
                                        </CardBody>
                                    </DialogContent>
                                    <br/>
                                    <DialogActions className={`${classes.modalFooter} ${classes.justifyContentCenter}`}>
                                        <Button round color="success" type="submit">
                                            Acceder
                                        </Button>
                                    </DialogActions>
                                </form>
                            </Card>
                        </Dialog>
                        {/* End Login Modal */}
                    </GridItem>

                    <GridItem xs={12} sm={6} md={6} lg={6}>
                        {/* Button open Signup Modal */}
                        <p>¿No tienes una cuenta?</p>
                        <Button
                            block
                            round
                            color="success"
                            onClick={() => this.handleClickOpen("signupModal")}
                        >
                            <Assignment /> Regístrate
                        </Button>
                        {/* End Button open Signup Modal */}

                        {/* Signup Modal */}
                        <Dialog
                            classes={{
                                root: classes.modalRoot,
                                paper: classes.modal + " " + classes.modalSignup
                            }}
                            open={this.state.signupModal}
                            TransitionComponent={Transition}
                            keepMounted
                            onClose={() => this.handleClose("signupModal")}
                            aria-labelledby="signup-modal-slide-title"
                            aria-describedby="signup-modal-slide-description"
                        >
                            {/* Custom Notification */}
                            <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} open={this.state.openNotification} autoHideDuration={6000} onClose={this.handleCloseNotification}>
                                <CustomNotification onClose={this.handleCloseNotification} variant={this.state.variantNotification} message={this.state.messageNotification}/>
                            </Snackbar>
                            {/* End Custom Notification */}

                            <Card plain className={classes.modalSignupCard}>
                                <DialogTitle
                                    id="signup-modal-slide-title"
                                    disableTypography
                                    className={classes.modalHeader}
                                >
                                    <Button
                                        simple
                                        className={classes.modalCloseButton}
                                        key="close"
                                        aria-label="Close"
                                        onClick={() => this.handleClose("signupModal")}
                                    >
                                        <Close className={classes.modalClose} />
                                    </Button>
                                    <h3 className={`${classes.cardTitle} ${classes.modalTitle}`}>
                                        Registrarse
                                    </h3>
                                </DialogTitle>
                                <DialogContent id="signup-modal-slide-description" className={classes.modalBody}>
                                    <GridContainer>
                                        <GridItem xs={12} sm={12} md={12} className={classes.mrAuto}>
                                            {/*<div className={classes.textCenter}>
                                                <Button justIcon round color="twitter">
                                                    <i className="fab fa-twitter" />
                                                </Button>
                                                {` `}
                                                <Button justIcon round color="dribbble">
                                                    <i className="fab fa-dribbble" />
                                                </Button>
                                                {` `}
                                                <Button justIcon round color="facebook">
                                                    <i className="fab fa-facebook-f" />
                                                </Button>
                                                {` `}
                                                <h4 className={classes.socialTitle}>
                                                    or be classical
                                                </h4>
                                            </div>*/}

                                            <form className={classes.form} onSubmit={this.onSubmitSignup}>
                                                <GridContainer justify="center">
                                                    <GridItem xs={12} sm={5} md={5}>

                                                        <CustomInput
                                                            id = "first_name"
                                                            formControlProps={{ fullWidth: true, className: classes.customFormControlClasses }}
                                                            labelText= {!!errors.first_name ? errors.first_name : "Nombre(s) *"}
                                                            error = {!!errors.first_name}
                                                            inputProps={{
                                                                value: this.state.first_name,
                                                                onChange: this.onChangeCustomInput(),
                                                                required: true
                                                            }}
                                                        />
                                                        <CustomInput
                                                            id = "last_name"
                                                            formControlProps={{ fullWidth: true, className: classes.customFormControlClasses }}
                                                            labelText= {!!errors.last_name ? errors.last_name : "Apellidos *"}
                                                            error = {!!errors.last_name}
                                                            inputProps={{
                                                                value: this.state.last_name,
                                                                onChange: this.onChangeCustomInput(),
                                                                required: true
                                                            }}
                                                        />
                                                        <CustomInput
                                                            id = "email"
                                                            formControlProps={{ fullWidth: true, className: classes.customFormControlClasses }}
                                                            labelText= {!!errors.email ? errors.email : "Email *"}
                                                            error = {!!errors.email}
                                                            inputProps={{
                                                                type: "email",
                                                                value: this.state.email,
                                                                onChange: this.onChangeCustomInput(),
                                                                required: true
                                                            }}
                                                        />
                                                        <CustomInput
                                                            id = "phone"
                                                            formControlProps={{ fullWidth: true, className: classes.customFormControlClasses }}
                                                            labelText= {!!errors.phone ? errors.phone : "Número celular *"}
                                                            error = {!!errors.phone}
                                                            inputProps={{
                                                                value: this.state.phone,
                                                                onChange: this.onChangeCustomInput(),
                                                                required: true
                                                            }}
                                                        />
                                                    </GridItem>

                                                    <GridItem xs={12} sm={5} md={5}>
                                                        <CustomInput
                                                            id = "usernameSignup"
                                                            formControlProps={{ fullWidth: true, className: classes.customFormControlClasses }}
                                                            labelText= {!!errors.username ? errors.username : "Nombre de usuario *"}
                                                            error = {!!errors.username}
                                                            inputProps={{
                                                                value: this.state.usernameSignup,
                                                                onChange: this.onChangeCustomInput(),
                                                                required: true
                                                            }}
                                                        />
                                                        <CustomInput
                                                            id = "passwordSignup"
                                                            formControlProps={{ fullWidth: true, className: classes.customFormControlClasses }}
                                                            labelText= {!!errors.password ? errors.password : "Contraseña *"}
                                                            error = {!!errors.password}
                                                            inputProps={{
                                                                type: "password",
                                                                value: this.state.passwordSignup,
                                                                onChange: this.onChangeCustomInput(),
                                                                required: true
                                                            }}
                                                        />
                                                        <CustomInput
                                                            id = "passwordConfirmation"
                                                            formControlProps={{ fullWidth: true, className: classes.customFormControlClasses }}
                                                            labelText= {!!errors.passwordConfirmation ? errors.passwordConfirmation : "Confirma la contraseña *"}
                                                            error = {!!errors.passwordConfirmation}
                                                            inputProps={{
                                                                type: "password",
                                                                value: this.state.passwordConfirmation,
                                                                onChange: this.onChangeCustomInput(),
                                                                required: true
                                                            }}
                                                        />
                                                    </GridItem>

                                                    <GridItem xs={12} sm={5} md={5} className={classes.topSpaced}>
                                                        <FormControlLabel
                                                            classes={{ label: classes.label }}
                                                            control={
                                                                <Checkbox
                                                                    tabIndex={-1}
                                                                    onClick={() => this.handleToggle(1)}
                                                                    checkedIcon={ <Check className={classes.checkedIcon} /> }
                                                                    icon={ <Check className={classes.uncheckedIcon} /> }
                                                                    classes={{ checked: classes.checked }}
                                                                    checked={ this.state.checked.indexOf(1) !== -1 }
                                                                />
                                                            }
                                                            label={ <span> Al continuar, acepto los{" "}<a href="/terminos-y-condiciones" target="_blank">Términos y Condiciones</a>.</span> }
                                                        />
                                                    </GridItem>

                                                    <GridItem xs={12} sm={5} md={5} className={classes.topSpaced}>
                                                        <div className={classes.textCenter}>
                                                            <Button round color="success" type="submit">
                                                                Registrarme
                                                            </Button>
                                                        </div>
                                                    </GridItem>
                                                </GridContainer>
                                            </form>
                                        </GridItem>
                                    </GridContainer>
                                </DialogContent>
                            </Card>
                        </Dialog>
                        {/* End Signup Modal */}
                    </GridItem>
                </GridContainer>
            </div>
        );
    }
}

SectionAuth.propTypes = {
    loginUser: PropTypes.func.isRequired,
    registerUser: PropTypes.func.isRequired,
    authReducer: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    authReducer: state.authReducer,
    errors: state.errors
});

export default connect(mapStateToProps, { loginUser, registerUser })( withStyles(javascriptStyles)(SectionAuth) );



// WEBPACK FOOTER //
// ./src/views/BookingFormPage/Sections/SectionAuth.js